export default "__VITE_ASSET__CCA27E9g__"